import AjaxUtils from './ajaxUtils';

const getBusinessOpportunitiesAnalytics = async () => AjaxUtils.get(`${envConfig.PLATFORM_SERVER_URL}/v2/business-opportunities/analytics`, true);

const getNewBusinessOpportunities = async () => AjaxUtils.get(`${envConfig.PLATFORM_SERVER_URL}/v2/business-opportunities/new`, true);

const patchBusinessOpportunitiesStatus = async () => AjaxUtils.patch(`${envConfig.PLATFORM_SERVER_URL}/v2/business-opportunities/dismiss`, { status: 'UNREAD' }, true);

const getBusinessOpportunitiesCount = async () => AjaxUtils.get(`${envConfig.PLATFORM_SERVER_URL}/v2/business-opportunities/count`, true);

export {
  getBusinessOpportunitiesAnalytics,
  getBusinessOpportunitiesCount,
  getNewBusinessOpportunities,
  patchBusinessOpportunitiesStatus,
};
